import React from 'react';
import OrderStatusTag from './order-status-tag';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getOrderMealsCount, getOrderStatus } from 'utils/functions';
import { ENUM_ORDER_STATUS } from 'utils/enum';
import { OrderType } from 'models/order.model';

type Props = {
  order: OrderType;
};

const OrderCard = (props: Props) => {
  const { order } = props;

  const totalMeals = getOrderMealsCount(order);
  const totalBrands = order.calculated_order.brand_ids && order.calculated_order.brand_ids.length;

  return (
    <Link to={`/orders/${order.order_code}`}>
      <div className='p-4 flex flex-col border-[0.8px] text-[#EAEBEB] rounded-[8px]'>
        <div className='flex justify-between'>
          <p className='text-[#2E3031] font-medium'>#{order.order_code}</p>
          <OrderStatusTag status={getOrderStatus(order)} />
        </div>
        <div className='flex justify-between text-[#6F7376] text-xs mt-3'>
          <p>
            {`${totalBrands} ${totalBrands === 1 ? 'brand' : 'brands'}, ${totalMeals} ${
              totalMeals === 1 ? 'item' : 'items'
            }`}
          </p>
          <p>
            {getOrderStatus(order) === ENUM_ORDER_STATUS.SCHEDULED
              ? moment(order.kitchen_start_order).format('DD/MM/YYYY hh:mm A')
              : moment(order.created_at).format('DD/MM/YYYY hh:mm A')}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default OrderCard;
